import './styles/ResponsiveImage.scss';

import { ImgHTMLAttributes } from 'react';

import ErrorLoadingImage from 'assets/errorLoadingImage.png';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

export const ResponsiveImage = ({ src, style }: Props) => {
  return (
    <img
      src={`${import.meta.env.VITE_S3_IMAGE_PROXY}/${src}`}
      className="responsive-image"
      style={{ ...style }}
      alt="item"
      onError={e => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = ErrorLoadingImage;
      }}
    />
  );
};
